import { createContext, useContext, useState } from "react";
import { currentMonth } from "@/lib/api";

const Ctx = createContext(null);

export function MonthProvider({ children }) {
  const [month, setMonth] = useState(currentMonth());
  return <Ctx.Provider value={{ month, setMonth }}>{children}</Ctx.Provider>;
}

export const useMonth = () => useContext(Ctx);
